
import { RouteObject } from "react-router-dom";
import { lazy } from "react";

const HomePage = lazy(() => import("../pages/home/page"));
const MembershipPage = lazy(() => import("../pages/membership/page"));
const OrderPage = lazy(() => import("../pages/order/page"));
const NotFound = lazy(() => import("../pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/membership",
    element: <MembershipPage />,
  },
  {
    path: "/order",
    element: <OrderPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
